<main>

    <mat-sidenav-container [class.opened]="opened">
        <mat-sidenav #sidenav mode="side" [(opened)]="opened" class="main-container" [class.mobile-open]="mobileOpen">
            <ostso-side-bar-double
                [titleCreate]="''"
                (toggle)="sidenav.toggle()"
                [opened]="sidenav.opened"
                (clickOutside)="onClickOutside()"
            />
        </mat-sidenav>

        <mat-sidenav-content>
            <section class="report-org">
                <div class="register-header">
                    <ostso-register-header (open)="mobileOpen=true"/>
                </div>
                <div class="filter-dialog">
                    <form class="form" [formGroup]="form">

                        <pas-choise title="Тип оценки" [items]="periods" [formControlName]="'period'">
                            <ng-template #name let-item>
                                {{ item.name }}
                            </ng-template>
                        </pas-choise>

                        <pas-choise title="Выбор года" [items]="years" [formControlName]="'year'">
                            <ng-template #name let-item>
                                {{ item.name }}
                            </ng-template>
                        </pas-choise>

                        @if (period?.name === 'Квартальная') {
                            <pas-choise title="Выбор квартала" [items]="quarters" [formControlName]="'quarter'">
                                <ng-template #name let-item>
                                    {{ item.name }}
                                </ng-template>
                            </pas-choise>
                        }

                        <pas-multi-select3
                            [formControlName]="'organization'"
                            title="Учреждение"
                            [customDataService]="analyticService"
                            customDialogMethod="apiAnalyticReportOrganizationsGet"
                            type="radio"
                            [options]="organizationOptions"
                        >
                            <ng-template #listItem let-item>
                                {{ item.name }}
                            </ng-template>

                            <ng-template #dialogList let-item>
                                <span>{{ item.name }}&nbsp;</span>

                                <span *ngIf="item.shortName">
                                    ({{ item.shortName }})&nbsp;
                                </span>

                                <span *ngIf="item.id">
                                    (ID:{{ item.id }})
                                </span>
                            </ng-template>
                        </pas-multi-select3>
                        <label for="allOrganization" class="all-organization__container">
                            <input class="all-organization" type="checkbox" id="allOrganization" formControlName="allOrganization">
                            <span>Отчет по всем учреждениям</span>
                        </label>
                    </form>

                </div>
                <div class="actions">
                    <button class="btn btn-blue" [style]="{color: 'white'}" mat-button (click)="onApply()"
                            [disabled]="!form.valid">Сформировать отчет
                    </button>
                    <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
                </div>


            </section>
        </mat-sidenav-content>
    </mat-sidenav-container>


</main>

